import { BarChart3 } from 'lucide-react';
import { useProjectContext } from '../../../hooks/useProjectContext';

const AnalyticsView = () => {
  const { activeProject } = useProjectContext();

  if (!activeProject) return null;

  const metrics = []; 
  return (
    <div className="space-y-6">
      <div className="flex items-center justify-between">
        <div>
          <h2 className="text-2xl font-bold text-gray-800">
            Project Analytics
          </h2>
          <p className="text-gray-600">
            Performance metrics for this project
          </p>
        </div>
        <BarChart3 className="w-8 h-8 text-orange-500" />
      </div>

      <div className="bg-white rounded-lg shadow p-6">
        {metrics.length === 0 ? (
          <p className="text-gray-500">
            No analytics data available yet for{' '}
            <strong>{activeProject.name}</strong>.
          </p>
        ) : (
          <div className="grid grid-cols-1 md:grid-cols-3 gap-4">
            {metrics.map((metric, index) => (
              <div
                key={index}
                className="p-4 bg-gray-50 rounded border"
              >
                <p className="text-sm text-gray-500">{metric.label}</p>
                <p className="text-xl font-bold">{metric.value}</p>
              </div>
            ))}
          </div>
        )}
      </div>
    </div>
  );
};

export default AnalyticsView;
